const getTimeOptions = () => {
  return Array.from({ length: 24 }, (_, i) => {
    const label = `${String(i).padStart(2, '0')}:00`;
    return { value: label, label };
  });
};
export default getTimeOptions;
